import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";
import {ReactComponent as FieldIcon} from '../../assets/svg/field_icon.svg';
import clsx from "clsx";
import {SHOW_WIDGET} from "../../store/spirs/actions";

export const WidgetShowButton: React.FC<{mobile: boolean}> = ({mobile}) => {
    const dispatch = useDispatch();
    const {widget, showWidget} = useSelector((state: StoreType) => state.spirs);

    function handleClick() {
        // Если десктопная версия, то функционал доступен вне зависимости от showWidget
        (!showWidget || !mobile) && dispatch(SHOW_WIDGET(!showWidget));
    }

    return (
        <button onClick={handleClick} className={clsx(
            "text-[#85A7A2] flex justify-center items-center"
        )}>
            <WidgetIcon fixtureWidgetId={widget.widgetId}/>
        </button>
    )
}

export const WidgetIcon: React.FC<{fixtureWidgetId?: number}> = ({fixtureWidgetId}) => {
    const {showWidget, widget: {widgetId}} = useSelector((state: StoreType) => state.spirs);
    return <FieldIcon className={clsx(
        'w-[30px] h-[30px]',
        showWidget && widgetId === fixtureWidgetId ? 'fill-[#FFFFFF]' : 'fill-[#8EA5A1]'
    )}/>;
}
